import { CashNoteDetail } from "./cash-note-detail";
import { ShopCurrency } from "./shop-currency";
import { StaffShift } from "./staff-shift";
import { SystemField } from "./system-field";

export class CashNote extends SystemField{ 
     amount?:number;
     staff_shifts_id?:string;
     payment_method_id?:string;
     shop_currency_id?:string;
     transaction_date?:string;

     //relationship
     staff_shift?:StaffShift;
     shop_currency?:ShopCurrency;
     
     cash_note_details?:CashNoteDetail[];
}
